module.exports = __webpack_public_path__ + "img/_warning.4e4373e3.svg";